import React from 'react';
import { Star } from 'lucide-react';

const testimonials = [
  {
    quote:
      'B2B Rev Co and I spent an hour together, and by the next week I had 5 campaigns that to this day are generating well over 15 appointments per month.',
    name: 'Jonathan Leonard',
    title: 'Financial Services Professional',
    result: '15+ appointments/month',
  },
  {
    quote:
      "In just about 6 weeks, because of our campaigns, I wrote 2 policies and have another handful in my pipeline. B2B Rev Co really WANTS you to succeed.",
    name: 'Wesley Carr',
    title: 'Insurance Professional',
    result: '2 policies + pipeline in 6 weeks',
  },
  {
    quote:
      'The team helped us attract several new clients in just a couple of months. They used our values and ideas to create compelling outreach that brought results.',
    name: 'Nathan Sebesta, CFP\u00AE',
    title: 'Access Wealth Strategies',
    result: 'Multiple new clients in 60 days',
  },
  {
    quote:
      "I wish I had a reset button so I could go back and do things again. They built an entire prospecting system that makes so much more sense.",
    name: 'Charles Pritchard III, MBA',
    title: 'Financial Services',
    result: 'Complete system transformation',
  },
];

const Testimonials = () => {
  return (
    <section data-testid="testimonials-section" className="section" style={{ backgroundColor: 'var(--bg-primary)' }}>
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="heading-lg mb-4">What Our Clients Say</h2>
          <p className="text-base md:text-lg" style={{ color: 'var(--text-secondary)' }}>
            Real words from real people. Not actors.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="card"
              data-testid={`testimonial-${t.name.split(' ')[0].toLowerCase()}`}
            >
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-current" style={{ color: 'var(--brand-warning)' }} />
                ))}
              </div>
              <blockquote className="text-base mb-6 leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
                "{t.quote}"
              </blockquote>
              <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                <div>
                  <p className="font-bold" style={{ color: 'var(--text-primary)' }}>{t.name}</p>
                  <p className="text-sm" style={{ color: 'var(--text-muted)' }}>{t.title}</p>
                </div>
                <span
                  className="text-xs font-semibold px-3 py-1 rounded-full"
                  style={{ backgroundColor: 'var(--bg-accent)', color: 'var(--brand-primary)' }}
                >
                  {t.result}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
